// @flow

const nequi = {
  dueDateFormat: 'dd/MM, HH:mm',
};

export default nequi;
